import * as z from "zod";

export const getRedoProductCards = {
  name: "getRedoProductCards" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        productId: z.string(),
        title: z.string(),
        imageUrl: z.string().optional(),
        variantCount: z.number(),
      }),
    ),
    warehouseLocationId: z.string().optional(),
  }),
};
